// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCC2np2TU1_jovTr69Hjdk4AXVzSS2otA0",
  authDomain: "virtual-arte-gallery.firebaseapp.com",
  projectId: "virtual-arte-gallery",
  storageBucket: "virtual-arte-gallery.appspot.com",
  messagingSenderId: "552078442632",
  appId: "1:552078442632:web:81d086d3d53c0a21399f3d",
  measurementId: "G-EYVNJ7D51T"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const analytics = getAnalytics(app);

export {app, db};